if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (evt.target.querySelector('.product-form__buttons .product-form__submit').getAttribute('data-custom-upsell-product-id')) {
          const main_product_id = document.querySelector('product-info > div > .product-form input[name="id"]').value;
          const main_product_quantity = formData.get('quantity');
          const upsell_product_id = evt.target.querySelector('.product-form__buttons .product-form__submit').getAttribute('data-custom-upsell-product-id');
          console.log("main_product_id: ", document.querySelector('product-info .product-form input[name="id"]').getAttribute('value'));
          formData.delete('id');
          formData.delete('quantity');

          formData.append(`items[0][id]`, upsell_product_id);
          formData.append(`items[0][quantity]`, 1);
          formData.append(`items[1][id]`, main_product_id);
          formData.append(`items[1][quantity]`, main_product_quantity);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                  this.fireCartAddEvent(response);
                  const upsellType = window.cartStrings.upsellType;
                  if (upsellType == "1") {
                    this.addRemoveProduct(response);
                  } else if (upsellType == "11") {
                    this.addRemoveMetaProduct(response);
                  }

                  if (window.cartStrings.cartSingleGift != "") {
                    this.addRemoveSingleProduct(response);
                  }
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              this.fireCartAddEvent(response);
              const upsellType = window.cartStrings.upsellType;
              if (upsellType == "1") {
                this.addRemoveProduct(response);
              } else if (upsellType == "11") {
                this.addRemoveMetaProduct(response);
              }

              if (window.cartStrings.cartSingleGift != "") {
                this.addRemoveSingleProduct(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      async addRemoveSingleProduct(parsedState) {
        await fetch("/cart.js")
          .then((response) => response.json())
          .then((response) => {
            var _self = this;
            var items = response.items;

            var hasProduct = false;
            var productId = document.querySelector(
              'input[name="product-single-gift"]'
            )?.value;
            items.forEach(function (item, index) {
              if (item.id == productId) {
                hasProduct = true;
              }
            });

            if (productId && !hasProduct) {
              if (response.total_price >= parseInt(window.cartStrings.cartThreshold)) {
                _self.addGiftProduct(productId, 1);
              } else {
                _self.cart.renderContents(parsedState);
              }
            } else {
              _self.cart.renderContents(parsedState);
            }
          });
      }

      async addRemoveProduct(parsedState) {
        await fetch("/cart.js")
          .then((response) => response.json())
          .then((response) => {
            var _self = this;
            var items = response.items;

            let count = 0;
            let countGift = 0;
            let hasGiftProduct = false;

            const productGiftId = document.querySelector('input[name="product-gift"]')?.value;

            items.forEach(function (item, index) {
              if (productGiftId) {
                const giftTriggerProducts = [
                  "zelesta-easybed-taupe-linnen",
                  "zelesta-easybed-donkergrijs-zilvergrijs",
                  "zelesta-easybed-turqoise-beige",
                  "zelesta-easybed-paars-antraciet",
                  "zelesta-easybed-chocolade-mokka",
                  "zelesta-easybed-blauw-mastiek",
                  "elesta-easybed-blauw-azuur",
                  "zelesta-easybed-paars-lila",
                  "zelesta-easybed-antraciet-rood",
                  "zelesta-easybed-chocolade-koraal",
                  "zelesta-easybed-lichtgrijs-gember",
                  "zelesta-easybed-lichtgrijs-zeegroen",
                  "zelesta-easybed-anijs-beige",
                  "zelesta-easybed-light-taupe-linnen",
                  "zelesta-easybed-light-donkergrijs-zilvergrijs",
                  "zelesta-easybed-light-antraciet-rood",
                  "zelesta-easybed-light-blauw-mastiek",
                  "zelesta-easybed-light-lichtgrijs-zeegroen",
                  "zelesta-easybed-light-lichtgrijs-gember",
                  "zelesta-easybed-light-paars-antraciet",
                  "zelesta-royalbed-pastel-grey-cream",
                  "zelesta-royalbed-green-cream",
                  "zelesta-royalbed-tender-grey",
                  "zelesta-royalbed-black",
                  "zelesta-royalbed-black-anthracite",
                  "zelesta-royalbed-pastel-green",
                  "royalbed-pastel-green-secundair",
                  "zelesta-royalbed-blue-anthracite",
                  "zelesta-royalbed-anthracite",
                  "zelesta-royalbed-blue",
                  "zelesta-royalbed-pastel-pink-tender-grey",
                  "zelesta-royalbed-pastel-pink-cream",
                  "zelesta-royalbed-light-pastel-grey-cream",
                  "zelesta-royalbed-light-pastel-pink-tender-grey",
                  "zelesta-royalbed-light-pastel-pink-cream",
                  "zelesta-royalbed-light-tender-grey",
                  "zelesta-royalbed-light-pastel-green",
                  "zelesta-wonderbed-royal-flowers",
                  "zelesta-wonderbed-patchwork-hearts",
                  "zelesta-wonderbed-golden-leaves",
                  "zelesta-wonderbed-jungle-vibe",
                  "zelesta-wonderbed-peacock-feathers",
                  "zelesta-wonderbed-jaguar-skin",
                  "zelesta-wonderbed-patchwork-pink",
                  "zelesta-wonderbed-old-dutch",
                  "zelesta-wonderbed-spring-flowers",
                  "zelesta-wonderbed-summer-flowers",
                  "zelesta-wonderbed-colorful-flowers",
                  "zelesta-wonderbed-zebra-skin",
                  "zelesta-wonderbed-purple-roses",
                  "zelesta-wonderbed-white-lily",
                  "zelesta-wonderbed-fresh-leaf",
                  "zelesta-wonderbed-light-patchwork-hearts",
                  "zelesta-wonderbed-light-patchwork-pink",
                  "zelesta-wonderbed-light-old-dutch",
                  "zelesta-wonderbed-light-purple-roses",
                  "zelesta-wonderbed-light-colorful-flowers",
                  "zelesta-wonderbed-light-summer-flowers",
                  "zelesta-wonderbed-light-spring-flowers",
                  "zelesta-wonderbed-light-white-lily",
                  "zelesta-wonderbed-light-jaguar-skin",
                  "zelesta-wonderbed-light-zebra-skin",
                  "zelesta-wonderbed-light-fresh-leaf",
                  "zelesta-wonderbed-light-golden-leaves",
                  "zelesta-wonderbed-light-jungle-vibe",
                  "zelesta-wonderbed-light-peacock-feathers",
                  "zelesta-wonderbed-light-royal-flowers",
                  "zelesta-wonderbed-extra-light-jaguar-skin",
                  "zelesta-wonderbed-extra-light-peacock-feathers",
                  "zelesta-wonderbed-extra-light-jungle-vibe",
                  "zelesta-wonderbed-extra-light-fresh-leaf",
                  "zelesta-wonderbed-extra-light-patchwork-pink",
                  "zelesta-wonderbed-extra-light-summer-flowers",
                  "elesta-wonderbed-extra-light-royal-flowers",
                  "zelesta-wonderbed-extra-light-patchwork-hearts",
                  "zelesta-wonderbed-extra-light-spring-flowers",
                  "zelesta-wonderbed-extra-light-golden-leaves",
                  "zelesta-wonderbed-extra-light-purple-roses",
                  "zelesta-wonderbed-4-seasons-double-taupe",
                  "zelesta-wonderbed-4-seasons-double-grey",
                  "zelesta-wonderbed-4-seasons-double-antracite",
                  "zelesta-wonderbed-4-seasons-double-navy",
                  "zelesta-wonderbed-4-seasons-double-black",
                  "zelesta-4-season-double-old-dutch",
                  "zelesta-4-season-double-royal-flowers",
                  "zelesta-4-season-double-peacock-feathers",
                  "zelesta-4-season-double-golden-leaves",
                  "zelesta-4-season-double-patchwork-hearts",
                  "zelesta-4-season-double-jaguar-skin",
                  "zelesta-kiddybed-lucky-lion",
                  "zelesta-kiddybed-smiling-dragon",
                  "zelesta-kiddybed-lama",
                  "zelesta-kiddybed-happy-bear",
                  "zelesta-kiddybed-space-dream",
                  "zelesta-kiddybed-unicorn",
                  "zelesta-teddybed-cream",
                  "zelesta-teddybed-green",
                  "zelesta-teddybed-anthracite",
                  "zelesta-teddybed-taupe",
                  "zelesta-premiumbed-olive-mint",
                  "zelesta-premiumbed-silk-coconut-cream",
                  "zelesta-premiumbed-salmon-peach",
                  "zelesta-wonderbed-kussenslopen-tiger-skin",
                  "zelesta-wonderbed-kussenslopen-white-lily",
                  "zelesta-wonderbed-kussenslopen-jaguar-skin",
                  "zelesta-wonderbed-kussenslopen-old-dutch",
                  "zelesta-wonderbed-kussenslopen-patchwork-hearts",
                  "zelesta-wonderbed-kussenslopen-patchwork-pink",
                  "zelesta-wonderbed-kussenslopen-spring-flowers",
                  "zelesta-wonderbed-kussensloop",
                  "zelesta-wonderbed-kussenslopen-tiger-skin",
                  "zelesta-wonderbed-kussenslopen-zebra-skin"
                ];

                if (item.id == productGiftId) {
                  count = parseInt(item.quantity);
                }

                if (giftTriggerProducts.includes(item.handle)) {
                  hasGiftProduct = true;
                  countGift += parseInt(item.quantity);
                }
              }
            });

            if (hasGiftProduct && countGift - count > 0) {
              _self.addGiftProduct(productGiftId, countGift - count);
            } else {
              _self.cart.renderContents(parsedState);
            }
          });
      }

      async addRemoveMetaProduct(parsedState) {
        await fetch("/cart.js")
          .then((response) => response.json())
          .then((response) => {
            var _self = this;
            var items = response.items;

            // Set to store processed handles
            let processedHandles = new Set();

            items.forEach(function (item, index) {
              var count = 0;
              var countGift = 0;
              var hasGiftProduct = false;

              var productGiftId = document.querySelector(`input[name="product-gift__${item.handle}"]`)?.value;
              if (productGiftId) {
                const giftTriggerProducts = window.cartStrings.upsellTriggerProduct;

                items.forEach(function (item, index) {
                  if (item.id == productGiftId) {
                    count += parseInt(item.quantity);
                  }
                });

                if (giftTriggerProducts.includes(item.handle)) {
                  if (!processedHandles.has(item.handle)) {
                    hasGiftProduct = true;
                    countGift += parseInt(
                      _self.checkTotalQuantity(items, item.handle)
                    );

                    // Mark handle as processed
                    processedHandles.add(item.handle);
                  }
                }

                if (hasGiftProduct && countGift - count > 0) {
                  _self.addGiftProduct(productGiftId, countGift - count);
                } else {
                  _self.cart.renderContents(parsedState);
                }
              }
            });
          });
      }

      checkTotalQuantity(data, handle) {
        let totalQuantity = 0;

        data.forEach((item) => {
          if (item.handle === handle) {
            totalQuantity += item.quantity;
          }
        });

        return totalQuantity;
      }

      addGiftProduct(product, quantity) {
        var data = {
          items: [
            {
              id: product,
              quantity: quantity,
            },
          ],
        };

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData();
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            // If the value is an array of objects, handle it accordingly
            if (Array.isArray(data[key])) {
              for (let i = 0; i < data[key].length; i++) {
                const item = data[key][i];
                for (const itemKey in item) {
                  if (item.hasOwnProperty(itemKey)) {
                    formData.append(`${key}[${i}][${itemKey}]`, item[itemKey]);
                  }
                }
              }
            } else {
              // If the value is a simple key-value pair
              formData.append(key, data[key]);
            }
          }
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            this.cart.renderContents(response);
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      fireCartAddEvent(response) {
        let addedItems;
        if(Array.isArray(response)) {
          addedItems =
            response.items?.map((it) => ({
              id: it.id,
              quantity: it.quantity,
              title: it.product_title,
            })) ?? [];
        } else {
          addedItems = response;
        }

        this.dispatchEvent(
          new CustomEvent("cart-add", {
            bubbles: true,
            composed: true,
            detail: {data: addedItems},
          })
        );
      }
    }
  );
}
